import React, { useMemo } from "react";
import type { StatefulDiaryT, StatefulTrackerViewT } from "../../../types";

const useCountDueTrackers = (diary: StatefulDiaryT) => {
	const remainingTrackers = useMemo(() => {
		if (!diary?.trackers_view) return 0;
		return diary.trackers_view.reduce(
			(total, tracker: StatefulTrackerViewT) =>
				total + (tracker.due_entries?.length || 0),
			0,
		);
	}, [diary?.trackers_view]);

	return remainingTrackers;
};

export default useCountDueTrackers;
